import Vue from 'vue';
import axios from 'axios';
import 'babel-polyfill';
import store from './store/index'; //一定要小写这个store 名字不能改，否则需要自己挂载$store的原形
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/mycss.css';
import App from './app';
import router from './router';
import Print from 'vue-print-nb'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Print); //注册
Vue.prototype.$axios = axios; //全局注册，使用方法为:this.$axios

axios.interceptors.request.use(config => {
    // 为请求头添加Authorization字段为服务端返回的token
    const user = sessionStorage.getItem('userInfo');
    
    if (user) {
        const token = 'Bearer ' + JSON.parse(user).token;
        config.headers.Authorization = token;
    }
    else {
        if (router.history.current.path === '/register')
            router.push({ path: "/register" });
        else
            router.push({ path: "/login" });
    }
    // return config是固定用法 必须有返回值
    return config;
})

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js